import { keysToSnakeCase } from 'utils/objectUtils'
import { USER_ACTION } from 'constants/toggleReasons'
import { API_VERSION } from 'constants/api'
import { isVisManager } from 'utils/visManager'
import { getClientAndAPIKey } from 'utils/actionsHelper'

export const CREATE_VISIT_REQUEST = 'CREATE_VISIT_REQUEST'
export const CREATE_VISIT_SUCCESS = 'CREATE_VISIT_SUCCESS'
export const CREATE_VISIT_FAILURE = 'CREATE_VISIT_FAILURE'
export const TOGGLE_MICROPHONE_REQUEST = 'TOGGLE_MICROPHONE_REQUEST'
export const TOGGLE_MICROPHONE_SUCCESS = 'TOGGLE_MICROPHONE_SUCCESS'
export const TOGGLE_MICROPHONE_FAILURE = 'TOGGLE_MICROPHONE_FAILURE'
export const TOGGLE_CAMERA_REQUEST = 'TOGGLE_CAMERA_REQUEST'
export const TOGGLE_CAMERA_SUCCESS = 'TOGGLE_CAMERA_SUCCESS'
export const TOGGLE_CAMERA_FAILURE = 'TOGGLE_CAMERA_FAILURE'
export const DECLINE_VISIT_REQUEST = 'DECLINE_VISIT_REQUEST'
export const DECLINE_VISIT_SUCCESS = 'DECLINE_VISIT_SUCCESS'
export const DECLINE_VISIT_FAILURE = 'DECLINE_VISIT_FAILURE'
export const GET_VISIT_OPTIONS_REQUEST = 'GET_VISIT_OPTIONS_REQUEST'
export const GET_VISIT_OPTIONS_SUCCESS = 'GET_VISIT_OPTIONS_SUCCESS'
export const GET_VISIT_OPTIONS_FAILURE = 'GET_VISIT_OPTIONS_FAILURE'
export const JOIN_VISIT_REQUEST = 'JOIN_VISIT_REQUEST'
export const JOIN_VISIT_SUCCESS = 'JOIN_VISIT_SUCCESS'
export const JOIN_VISIT_FAILURE = 'JOIN_VISIT_FAILURE'
export const ACCEPT_VISIT_REQUEST = 'ACCEPT_VISIT_REQUEST'
export const ACCEPT_VISIT_SUCCESS = 'ACCEPT_VISIT_SUCCESS'
export const ACCEPT_VISIT_FAILURE = 'ACCEPT_VISIT_FAILURE'
export const JOIN_MONITOR_REQUEST = 'JOIN_MONITOR_REQUEST'
export const JOIN_MONITOR_SUCCESS = 'JOIN_MONITOR_SUCCESS'
export const JOIN_MONITOR_FAILURE = 'JOIN_MONITOR_FAILURE'
export const END_VISIT_REQUEST = 'END_VISIT_REQUEST'
export const END_VISIT_SUCCESS = 'END_VISIT_SUCCESS'
export const END_VISIT_FAILURE = 'END_VISIT_FAILURE'
export const SEND_FEEDBACK_REQUEST = 'SEND_FEEDBACK_REQUEST'
export const SEND_FEEDBACK_SUCCESS = 'SEND_FEEDBACK_SUCCESS'
export const SEND_FEEDBACK_FAILURE = 'SEND_FEEDBACK_FAILURE'
export const CANCEL_VISIT_REQUEST = 'CANCEL_VISIT_REQUEST'
export const CANCEL_VISIT_SUCCESS = 'CANCEL_VISIT_SUCCESS'
export const CANCEL_VISIT_FAILURE = 'CANCEL_VISIT_FAILURE'
export const GET_USER_COUNTRY_URL_REQUEST = 'GET_USER_COUNTRY_URL_REQUEST'
export const GET_USER_COUNTRY_URL_SUCCESS = 'GET_USER_COUNTRY_URL_SUCCESS'
export const GET_USER_COUNTRY_URL_FAILURE = 'GET_USER_COUNTRY_URL_FAILURE'

export function createVisit(data) {
  const { client, apiKey } = getClientAndAPIKey()

  return {
    types: [
      CREATE_VISIT_REQUEST,
      CREATE_VISIT_SUCCESS,
      CREATE_VISIT_FAILURE
    ],
    method: 'POST',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/visits`,
    body: enrichWithApiKey({
      visit: keysToSnakeCase(data)
    }, apiKey)
  }
}

export function toggleMicrophone(act, reason = USER_ACTION) {
  const { client } = getClientAndAPIKey()

  return {
    types: [
      TOGGLE_MICROPHONE_REQUEST,
      TOGGLE_MICROPHONE_SUCCESS,
      TOGGLE_MICROPHONE_FAILURE
    ],
    method: 'POST',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/visits/sound`,
    body: {
      act,
      reason
    }
  }
}

export function toggleCamera(act, reason = USER_ACTION) {
  const { client } = getClientAndAPIKey()

  return {
    types: [
      TOGGLE_CAMERA_REQUEST,
      TOGGLE_CAMERA_SUCCESS,
      TOGGLE_CAMERA_FAILURE
    ],
    method: 'POST',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/visits/video`,
    body: {
      act,
      reason
    }
  }
}

export function declineVisit(onSuccess = () => {}) {
  const { client } = getClientAndAPIKey()

  return {
    types: [
      DECLINE_VISIT_REQUEST,
      DECLINE_VISIT_SUCCESS,
      DECLINE_VISIT_FAILURE
    ],
    method: 'PUT',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/visits/decline`,
    onSuccess
  }
}

export function getVisitCreationOptions(appointmentId) {
  const { client, apiKeyURLParam } = getClientAndAPIKey()

  return {
    types: [
      GET_VISIT_OPTIONS_REQUEST,
      GET_VISIT_OPTIONS_SUCCESS,
      GET_VISIT_OPTIONS_FAILURE
    ],
    method: 'GET',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/visits/creation_options?visit[appointment_id]=${appointmentId}${apiKeyURLParam}`
  }
}

export function joinVisit(appointmentId) {
  const { client, apiKeyURLParam } = getClientAndAPIKey()

  return {
    types: [
      JOIN_VISIT_REQUEST,
      JOIN_VISIT_SUCCESS,
      JOIN_VISIT_FAILURE
    ],
    method: 'GET',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/visits/join?appointment_id=${appointmentId}${apiKeyURLParam}`
  }
}

export function acceptVisit(paymentMethod) {
  const { client } = getClientAndAPIKey()

  const body = { payment_method: paymentMethod }
  const action = {
    types: [
      ACCEPT_VISIT_REQUEST,
      ACCEPT_VISIT_SUCCESS,
      ACCEPT_VISIT_FAILURE
    ],
    method: 'PUT',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/visits/accept`,
  }
  return paymentMethod ? { ...action, body } : action
}

export function joinMonitor(idValue, isVideoWall) {
  const { client, apiKeyURLParam } = getClientAndAPIKey()

  const idField = isVisManager() ? 'appointment_id' : 'conference_id'
  let url = `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/visits/monitor?${idField}=${idValue}${apiKeyURLParam}`
  if (isVideoWall) {
    url += '&monitor_type=video_wall'
  }
  return {
    types: [
      JOIN_MONITOR_REQUEST,
      JOIN_MONITOR_SUCCESS,
      JOIN_MONITOR_FAILURE
    ],
    method: 'GET',
    url
  }
}

export function endVisit(onSuccess = () => {}) {
  const { client } = getClientAndAPIKey()

  return {
    types: [
      END_VISIT_REQUEST,
      END_VISIT_SUCCESS,
      END_VISIT_FAILURE
    ],
    method: 'POST',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/visits/end`,
    onSuccess
  }
}

export function sendFeedback(rating, feedback) {
  const { client } = getClientAndAPIKey()

  return {
    types: [
      SEND_FEEDBACK_REQUEST,
      SEND_FEEDBACK_SUCCESS,
      SEND_FEEDBACK_FAILURE
    ],
    method: 'POST',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/visits/feedback`,
    body: {
      rating,
      feedback
    }
  }
}

export function cancelVisit(appointmentId, onSuccess = () => {}) {
  const { client, apiKey } = getClientAndAPIKey()

  return {
    types: [
      CANCEL_VISIT_REQUEST,
      CANCEL_VISIT_SUCCESS,
      CANCEL_VISIT_FAILURE
    ],
    method: 'POST',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/visits/cancel`,
    body: enrichWithApiKey({
      visit: {
        appointment_id: appointmentId
      }
    }, apiKey),
    onSuccess
  }
}

export function getGvcUrlByJwt(jwt, onSuccess = () => {}) {
  const { client } = getClientAndAPIKey()

  return {
    types: [
      GET_USER_COUNTRY_URL_REQUEST,
      GET_USER_COUNTRY_URL_SUCCESS,
      GET_USER_COUNTRY_URL_FAILURE
    ],
    method: 'GET',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/users/gvc_url_by_jwt?jwt=${jwt}`,
    onSuccess
  }
}

function enrichWithApiKey(body, apiKey) {
  if (apiKey) {
    body.api_key = encodeURIComponent(apiKey)
  }
  return body
}
